import { Address } from "viem";

import { plume } from "@/lib/wagmi";

export enum QueryKey {
  LatestQuest = "Latest Quest",
  AllQuests = "All Quests",
  UserQuests = "User Quests",
  Badges = "Badges",
  SelectedQuest = "Selected Quest",
  AllApps = "All Apps",
  Leaderboard = "Leaderboard",
  RoycoPositions = "RoycoPositions",
  StatsForWalletAddress = "Stats For Wallet Address",
  PPScores = "PPScores",
  SeasonOneClaims = "Season One Claims",
  SeasonOneStats = "Season One Stats",
  StatsForMe = "Stats For Me",
  TokenDetails = "Token Details",
  UserExperienceMeta = "User Experience Metadata",
  WalletBalances = "Wallet Balances",
  VaultPositions = "VaultPositions",
  UnderlyingStrategies = "UnderlyingStrategies",
  NucleusVaults = "NucleusVaults",
  VaultExchangeRateToUSD = "VaultExchangeRateToUSD",
  RoycoPositionsFromNucleus = "RoycoPositionsFromNucleus",
  GetWithdrawExchangeRate = "GetWithdrawExchangeRate",
  RoycoTokenQuote = "RoycoTokenQuote",
  RoycoPositionsForVaultKey = "RoycoPositionsForVaultKey",
  Compliance = "Compliance",
  ApyDataWithBoostIncentives = "ApyDataWithBoostIncentives",
  TvlData = "TvlData",
  GuardiansOfPlumeStats = "GuardiansOfPlumeStats",
  GuardiansOfPlumeUserStats = "GuardiansOfPlumeUserStats",
}

export const plumeMainnetId = 98866;
export const plumeTestnetId = 98867;
export const wrappedPlumeTokenAddress =
  "0xea237441c92cae6fc17caaf9a7acb3f953be4bd1";
export const wrappedPlumeDecimals = 18;
export const wrappedPlumeSymbol = "WPLUME";

// This could be refactored out to and env variable later
export const dailySpinChainId = plumeMainnetId;
export const dailySpinChain = plume;
export const supportedNetworks = [plume];

export const plumeWrappedTokenAddress =
  "0xEa237441c92CAe6FC17Caaf9a7acB3f953be4bd1";

export const usdceTokenAddress =
  "0x78adD880A697070c1e765Ac44D65323a0DcCE913" satisfies Address;
export const nativeUsdcTokenAddress =
  "0x222365EF19F7947e5484218551B56bb3965Aa7aF" satisfies Address;
export const plumeOnEthAddress =
  "0x4c1746a800d224393fe2470c70a35717ed4ea5f1" satisfies Address;
export const zeroAddress =
  "0x0000000000000000000000000000000000000000" satisfies Address;

export const MINIMUM_VIABLE_PLUME_TOKEN_AMOUNT = 1;

export enum LocalStorageKey {
  FurthestStepSeen = "Furthest Step Seen",
  StartingExperience = "Starting Experience",
  UseAuthenticatedLoadingState = "useAuthenticatedLoadingState",
  PlumeDeviceId = "PlumeDeviceId",
}
export enum LeaderboardRecordCategory {
  Leaderboard = "leaderboard",
  BattleGroup = "battleGroup",
}

export const MAX_PAGE_WIDTH = 1200;

export const MS_IN_SECOND = 1000;
export const SECONDS_IN_MINUTE = 60;
export const SECONDS_IN_HOUR = 3600;
export const SECONDS_IN_DAY = 86400;
export const SECONDS_IN_YEAR = 31536000;

export const STALE_TIME_VERY_SHORT = 5 * MS_IN_SECOND; // 5 seconds
export const STALE_TIME_SHORT = 30 * MS_IN_SECOND; // 30 seconds
export const STALE_TIME_MEDIUM = 5 * SECONDS_IN_MINUTE * MS_IN_SECOND; // 5 minutes
export const STALE_TIME_LONG = 30 * SECONDS_IN_MINUTE * MS_IN_SECOND; // 30 minutes
export const STALE_TIME_VERY_LONG = 4 * SECONDS_IN_HOUR * MS_IN_SECOND; // 4 hours

export const GC_TIME_SHORT = 1 * SECONDS_IN_MINUTE * MS_IN_SECOND; // 1 minute
export const GC_TIME_MEDIUM = 5 * SECONDS_IN_MINUTE * MS_IN_SECOND; // 5 minutes
export const GC_TIME_LONG = 30 * SECONDS_IN_MINUTE * MS_IN_SECOND; // 30 minutes
export const GC_TIME_VERY_LONG = 4 * SECONDS_IN_HOUR * MS_IN_SECOND; // 4 hours

//////////////// URLS ////////////////////
export const SWAP_URL =
  "https://app.rooster.trade/swap?input=0x0000000000000000000000000000000000000000&output=0xdddD73F5Df1F0DC31373357beAC77545dC5A6f3F";
export const STAKING_URL = "https://staking.plumenetwork.xyz";
export const PUSD_URL = "https://pusd.plume.org/";
export const PETH_URL = "https://peth.plume.org/";
export const PORTAL_GUIDE_URL = "https://plume.org/blog/portal";
export const PLUME_VISION_URL = "https://plume.org/blog/pre-genesis";
export const AIRDROP_GUIDE_URL = "https://plume.org/blog/plume-airdrop";
export const ARBITRUM_BRIDGE_URL =
  "https://bridge.arbitrum.io/?destinationChain=plume-mainnet&sourceChain=ethereum";
export const STARGATE_BRIDGE_URL =
  "https://stargate.finance/bridge?srcChain=base&srcToken=0x833589fCD6eDb6E08f4c7C32D4f71b54bdA02913&dstChain=plumephoenix&dstToken=0x78adD880A697070c1e765Ac44D65323a0DcCE913";
export const BUILDER_HUB_URL = "https://plume.org/builder-hub";
export const MATRIX_DOCK_GOLD_URL =
  "https://app.rooster.trade/explore/tokens/0xa0c4f78a29ead4abf6b7f5b3f0d05c0f3eab8ddf";
export const MYSTIC_URL = "https://app.mysticfinance.xyz/";
export const NEST_AUDIT_URL = "https://docs.nest.credit/audits";
export const NEST_TREASURY_VAULT_URL =
  "https://app.nest.credit/nest-treasury-vault?utm_source=plume-portal&utm_content=treasury-vault";
export const NEST_RWA_VAULT_URL =
  "https://app.nest.credit/nest-rwa-vault?utm_source=plume-portal&utm_content=rwa-vault";
export const NEST_ELIXIR_VAULT_URL =
  "https://app.nest.credit/nest-elixir-vault?utm_source=plume-portal&utm_content=elixir-vault";

export const ROYCO_DOMAIN_URL = "https://plume.royco.org";
export const ROYCO_PORTFOLIO_URL = `${ROYCO_DOMAIN_URL}/portfolio`;
export const ROYCO_API_URL = "https://api.royco.org/api/v1";
export const ROYCO_MARKET_ACTION_URL = `${ROYCO_API_URL}/action/recipe/ap/market`;
export const PLUME_X_URL = "https://x.com/plumenetwork";
export const PLUME_TG_URL = "https://t.me/plumenetwork_community";
export const PLUME_DISCORD_URL = "https://discord.com/invite/plume-network";
//////////////// HOME SCREEN BANNERS ///////////////////
export const DISMISSED_BANNER_PREFIX = "dismissed";
export const BANNER_EXPIRATTION_PREFIX = "exp";

// NOTE: IF YOU ADD A BANNER ID, YOU MUST ADD IT TO THE ALL_BANNER_IDS LIST
export const PLUME_STAKING_BANNER_ID = "plume-staking";
export const OPTIMIZER_BANNER_ID = "optimizer";
export const LATEST_QUEST_BANNER_ID = "latest-quest";
export const DAILY_SPIN_BANNER_ID = "daily-spin";
export const CLAIM_BATTLE_WON_BANNER_ID = "claim-battle-won";
export const RAFFLE_WON_BANNER_ID = "raffle-won";
export const STAND_WITH_CRYPTO_BANNER_ID = "stand-with-crypto";
export const GUARDIANS_OF_PLUME_BANNER_ID = "guardians-of-plume";

export const EUGENE_WALLET_ADDRESS =
  "0xDE1509CC56D740997c70E1661BA687e950B4a241";

export const ALL_BANNER_IDS = [
  PLUME_STAKING_BANNER_ID,
  OPTIMIZER_BANNER_ID,
  LATEST_QUEST_BANNER_ID,
  DAILY_SPIN_BANNER_ID,
  CLAIM_BATTLE_WON_BANNER_ID,
  RAFFLE_WON_BANNER_ID,
  STAND_WITH_CRYPTO_BANNER_ID,
];
export enum AppRoute {
  Home = "/",
  Optimizer = "/optimizer",
  OptimizerVault = "/optimizer/:vaultAddress",
  OptimizerVaultDeposit = "/optimizer/:vaultAddress/deposit",
  RoycoOnlyWithdraw = "/optimizer/:vaultAddress/withdraw-royco",
  VaultOnlyWithdraw = "/optimizer/:vaultAddress/withdraw-vault",
  OptimizerVaultWithdraw = "/optimizer/:vaultAddress/withdraw",
  Quests = "/level-up",
  QuestDetails = "/level-up/:questId",
  Apps = "/apps",
  AppDetail = "/apps/:appId",
  MyProfile = "/profile/me",
  Profile = "/profile/:address",
  Leaderboard = "/leaderboard",
  DailySpin = "/daily-spin",
  Bridge = "/bridge",
  BridgeWithDefaults = "/bridge?fromChain=1&fromToken=0x0000000000000000000000000000000000000000&toChain=98866&toToken=0x0000000000000000000000000000000000000000",
  Swap = "/swap",
  // Swap = '/swap?fromChain=98866&fromToken=0x0000000000000000000000000000000000000000&toChain=98866',
  // PlumeStaking = '/plume-staking', // Uncomment when added to navbar
  SeasonOneClaim = "/season",
  OptimizerVaultWithdrawSteps = "/optimizer/:vaultAddress/withdraw/steps",
  AdminPointsCompare = "/admin/points/compare",
  AdminBattleGroupReview = "/admin/battlegroups/review",
  AdminAirdropSummary = "/admin/airdrop/summary",
  GuardiansOfPlume = "/guardians",
}

export const SERVICE_NAME = "Plume Portal";

export const TVL_TIERS = [
  500, 1_000, 5_000, 10_000, 50_000, 100_000, 150_000, 200_000, 300_000,
  400_000, 600_000, 800_000, 1_000_000,
];

export const GEORESTRICTED_BANNER_HEIGHT_PX = 68;
export const ERROR_BANNER_HEIGHT_PX = 48;

// the initial airdrop claim %
export const INITIAL_CLAIM_MULTIPLIER = 0.25;

export const ESTIMATED_APY_TOOLTIP_TEXT =
  "This APY is a conservative estimate and is expected to climb to over 20% APY as lending market liquidity gets seeded and looping can be increased.";

export const PUSD_TOKEN = {
  symbol: "pUSD",
  name: "pUSD",
  address: "0xdddd73f5df1f0dc31373357beac77545dc5a6f3f",
  decimals: 6,
  chainId: plumeMainnetId,
  verified: true,
  logoURI:
    "https://cdn.prod.website-files.com/670fc97cba6a0b3f2e579538/676e9b2d7b188175ad742137_Token.svg",
};

export const MAX_SLIPPAGE_THRESHOLD = 1; // 1%
export const MAX_PRICE_IMPACT_THRESHOLD = 3; // 3%

export const outage = false;
export const portfolioTrackingOutage = false;

export const isPPDeprecated = import.meta.env.VITE_PP_DEPRECATED === "true";
